import { CardMedia, Skeleton, Typography, useMediaQuery } from '@mui/material'
import { Box } from '@mui/system'

const UpskillHeader = ({ name, designation, profile_picture, isLoading }) => {
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white.main',
        padding: '24px 20px',
        borderRadius: '4.5px 4.5px 0 0',
        border: '1px solid #E5E5E5',
        borderBottom: 0,
        gap: '20px',
      }}
    >
      <Box>
        {isLoading ? (
          <Skeleton
            variant="circular"
            sx={{
              height: '45px',
              width: '45px',
            }}
          />
        ) : profile_picture ? (
          <CardMedia
            component="img"
            sx={{
              height: '45px',
              width: '45px',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
            src={profile_picture}
          />
        ) : (
          <Box
            width={'45px'}
            height={'45px'}
            borderRadius="50%"
            bgcolor="alternate.main"
            color="white.main"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              textTransform: 'capitalize',
            }}
          >
            {name?.charAt(0)}
          </Box>
        )}
      </Box>

      <Box>
        <Typography variant={isLarge ? 'h4' : 'body1'}>
          {isLoading ? <Skeleton variant="text" width={150} /> : name}
        </Typography>
        <Typography variant={isLarge ? 'body1' : 'body2'} color="light-gray-text.main">
          {isLoading ? <Skeleton variant="text" width={120} /> : designation}
        </Typography>
      </Box>
    </Box>
  )
}
export default UpskillHeader
